import { Button, Stack } from '@mui/material';
import { columnType } from 'components/table/types';
import { formatDateTime } from 'constants/global.constants';
import type { HyperMonitoringOperationRecord } from 'types/hyper-monitoring.types';

export const buildColumns = (
	t: any,
	onResendClick: (row: HyperMonitoringOperationRecord, event: React.MouseEvent<HTMLElement>) => void,
	onManualReportClick: (row: HyperMonitoringOperationRecord, event: React.MouseEvent<HTMLElement>) => void,
	actionLoadingById: Record<string, boolean>,
	canReplay: boolean,
	canManualReport: boolean
): columnType[] => {
	const columns: columnType[] = [
		{
			fieldId: 'operationId',
			name: 'companyHebrewName',
			title: t('page.hyperMonitoring.field.companyHebrewName'),
			type: 'string',
			sortable: false,
		},
		{
			fieldId: 'operationId',
			name: 'hyperAccountNumber',
			title: t('page.hyperMonitoring.field.hyperAccountNumber'),
			type: 'string',
			sortable: false,
		},
		{
			fieldId: 'operationId',
			name: 'beneficiaryName',
			title: t('page.hyperMonitoring.field.beneficiaryName'),
			type: 'string',
			sortable: false,
		},
		{
			fieldId: 'operationId',
			name: 'hyperFailureReceivedAt',
			title: t('page.hyperMonitoring.field.hyperFailureReceivedAt'),
			type: 'custom',
			sortable: false,
			customValueHandle: (value) => (value ? formatDateTime(value) : '—'),
		},
	];

	if (!canReplay) {
		return columns;
	}

	columns.push({
		fieldId: 'operationId',
		name: 'actions',
		title: t('page.hyperMonitoring.field.actions'),
		type: 'custom',
		sortable: false,
		customValueHandle: (_value, row: Record<string, any>) => {
			const isActionLoading = !!actionLoadingById[row.operationId];

			return (
				<Stack direction="row" spacing={1}>
					<Button
						variant="contained"
						color="primary"
						size="small"
						disabled={isActionLoading}
						onClick={(event) => {
							event.stopPropagation();
							onResendClick(row as HyperMonitoringOperationRecord, event);
						}}
					>
						{t('page.hyperMonitoring.actions.resendRecord')}
					</Button>
					{canManualReport ? (
						<Button
							variant="outlined"
							color="inherit"
							size="small"
							disabled={isActionLoading}
							onClick={(event) => {
								event.stopPropagation();
								onManualReportClick(row as HyperMonitoringOperationRecord, event);
							}}
						>
							{t('page.hyperMonitoring.actions.manualReport')}
						</Button>
					) : null}
				</Stack>
			);
		},
	});

	return columns;
};
